import React from "react";
import { RotateCcwClockIcon } from "lucide-react";
import style from "./RebidNotice.module.scss";

const RebidNotice = ({ children }) => (
  <div className={style.notice} role="status">
    <RotateCcwClockIcon
      className={style.icon}
      size={20}
      color="#0D3B66"
      aria-hidden="true"
    />
    <span>{children}</span>
  </div>
);

export default RebidNotice;
